import axios from 'axios';
import { parcharTabla } from '../Components/Utils/Utils';
import { useGetToken } from "../Hooks/CustomHooks";
import * as KeyNames from './KeyNames';
import * as PathNames from './PathNames';

//Login
export const getLogin = async (args) => {
    let response;

    let params = new URLSearchParams({
        email: args.email,
        password: args.password,

    }).toString();

    await (axios.post(PathNames.Login + `?` + params).then(res => response = res.data));
    return response;
}

//Forgot password
export const postForgotPasswordRequest = async (args) => {
    let response;

    let params = new URLSearchParams({
        email: args.email,
        resetToken: args.resetToken,
        expirationTime: args.expirationTime,
        url: args.url
    }).toString();

    await (axios.post(PathNames.ForgotPassword + '?' + params,
        {
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//ResetPassword
export const getResetPassword = async (args) => {
    let response;
    await (axios.post(PathNames.ResetPassword + `?resetToken=${args.resetToken}`)
        .then(res => response = res.data));
    return response;
}

//Change password
export const postChangePassword = async (args) => {
    let response;
    await (axios.post(PathNames.ChangePassword + `?newPassword=${args.newPassword}&resetToken=${args.resetToken}`
    ).then(res => response = res.data));
    return response;
}

//Get User
export const getUser = async (token) => {
    let response;
    const email = localStorage.getItem(KeyNames.SessionData + " email") ?
        localStorage.getItem(KeyNames.SessionData + " email") :
        sessionStorage.getItem(KeyNames.SessionData + " email");

    await (axios.get(PathNames.User + `?email=${email}`,
        { headers: { 'Authorization': `Bearer ${token}` } }
    ).then(res => response = res.data));

    return response;

}

//Get UsersList
export const getUsersList = async (args) => {

    let response;
    await (axios.get(PathNames.UsersList + `?roleList=${args.roleList}`,

        { headers: { 'Authorization': `Bearer ${args.token}` } }
    ).then(res => response = res.data));
    // let dataTablaAux = response.data;
    // response.data = {};
    // response.data.table = dataTablaAux;
    return response
}

//Get roleList
export const getRoleList = async (args) => {

    let response;
    await (axios.get(PathNames.RoleList,
        { headers: { 'Authorization': `Bearer ${args.token}` } }
    ).then(res => response = res.data));
    return response;
}

//Add User
export const addRole = async (args) => {
    let response;
    let params = new URLSearchParams({
        // roleId: args.newRole.name.trim().toLowerCase(),
        name: args.newRole.name,
        listPermissions: args.newRole.listPermissions.map(permision => permision.id),
    }).toString();

    await (axios.post(PathNames.AddRole + '?' + params, {},
        {
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Edit User
export const editRole = async (args) => {
    let response;
    let params = new URLSearchParams({

        roleId: args.updatedRole.id,//.trim().toLowerCase(),
        name: args.updatedRole.name,//,
        listPermissions: args.updatedRole.listPermissions.map(permision => permision.id),
    }).toString();
    await (axios.post(PathNames.EditRole + '?' + params, {},
        {
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get removeRole
export const removeRole = async (args) => {
    console.log('Remove');
    let response;

    await (axios.post(PathNames.RemoveRole + `?roleId=${args.role}`,
        {
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}



//Get permissionList
export const getPermissionList = async (args) => {
    let response;
    await (axios.get(PathNames.PermissionList,
        { headers: { 'Authorization': `Bearer ${args.token}` } }
    ).then(res => response = res.data));
    return response;
}



//Add User
export const addUser = async (args) => {
    let response;

    let params = new URLSearchParams({
        userEmail: args.newUser.email,
        name: args.newUser.name,
        role: args.newUser.role,
        resetToken: args.newUser.resetToken,
        url: args.newUser.url,
        dni: (args.newUser.dni) ? args.newUser.dni : ''
    }).toString();

    await (axios.post(PathNames.NewUser + '?' + params, {},
        {
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Edit User
export const editUser = async (args) => {
    let response;
    let params = new URLSearchParams({
        userEmail: args.updatedUser.email,
        name: args.updatedUser.name,
        role: args.updatedUser.role,
        dni: args.updatedUser.dni,
        userState: (args.updatedUser.userState === "Activo" ? 'A' : 'I')
    }).toString();

    await (axios.post(PathNames.EditUser + '?' + params, {},
        {
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}


//------DASHBOARD------------

//Get Dashboard Afluencia 
export const DashboardAfluencia = async (args) => {
    let response;
    await (axios.get(PathNames.DashboardAfluencia,
        {},
        {
            headers: { 'Authorization': `Bearer ${args.token}` },
        }
    ).then(res => response = res.data));
    return response;
}

//Get Dashboard Indicadores Princiaples 
export const DashboardIndicadoresPrincipales = async (args) => {
    let response;
    await (axios.get(PathNames.DashboardIndicadoresPrincipales,
        {},
        {
            headers: { 'Authorization': `Bearer ${args.token}` },
        }
    ).then(res => response = res.data));
    return response;
}

//Get Dashboard Analisis Ventas 
export const DashboardAnalisisVentas = async (args) => {
    let response;
    await (axios.get(PathNames.DashboardAnalisisVentas,
        {
            params: {
                graphTypeId: args.graphType,
                token: args.token,
                anio1: args.anio1,
                anio2: args.anio2
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get Comparativo Ventas
export const ComparativoVentas = async (args) => {
    let response;
    await (axios.get(PathNames.ComparativoDeVentas,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                fechaInicio: args.fechaInicio,
                fechaFin: args.fechaFin,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get Evolucion Ventas Totales
export const EvolucionVentasTotales = async (args) => {
    let response;
    await (axios.get(PathNames.EvolucionVentasTotales,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                mesCorte: args.mesCorte,
                anio: args.anio,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get Evolucion Ventas Cumplimiento
export const EvolucionVentasCumplimiento = async (args) => {
    let response;
    await (axios.get(PathNames.EvolucionVentasCumplimiento,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                mesCorte: args.mesCorte,
                anio1: args.anio1,
                anio2: args.anio2,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` },
        }
    ).then(res => response = res.data));
    return response;
}

//Get Evolucion Ventas Desglose Mes
export const EvolucionVentasDesgloseMes = async (args) => {
    let response;
    await (axios.get(PathNames.EvolucionVentasDesgloseMes,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                mesCorte: args.mesCorte,
                anio: args.anio,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get Evolucion Ventas Tienda Totales
export const EvolucionVentasTiendaTotales = async (args) => {
    let response;
    await (axios.get(PathNames.EvolucionVentasTiendaTotales,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                mesCorte: args.mesCorte,
                anio: args.anio,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get Evolucion Ventas Tienda Cumplimiento
export const EvolucionVentasTiendaCumplimiento = async (args) => {
    let response;
    await (axios.get(PathNames.EvolucionVentasTiendaCumplimiento,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                mesCorte: args.mesCorte,
                anio1: args.anio1,
                anio2: args.anio2,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` },
        }
    ).then(res => response = res.data));
    return response;
}

//Get Evolucion Ventas Tienda Desglose Mes
export const EvolucionVentasTiendaDesgloseMes = async (args) => {
    let response;
    await (axios.get(PathNames.EvolucionVentasTiendaDesgloseMes,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                mesCorte: args.mesCorte,
                anio: args.anio,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get Diario Comparativo Ventas
export const DiarioComparativoVentas = async (args) => {
    let response;
    await (axios.get(PathNames.DiarioComparativoVentas,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                inflacion: args.inflacion,
                diaMesInicio: args.diaMesInicio,
                diaMesFin: args.diaMesFin,
                anio1: args.anio1,
                anio2: args.anio2,
                token: args.token,
                sss: args.sss
            },
            headers: {
                'Authorization': `Bearer ${args.token}`,
            }
        }
    ).then(res => response = res.data));
    if (response.data)
        return parcharTabla(response);
    else
        return {
            "errorId": null,
            "message": "Acción ejecutada satisfactoriamente.",
            "success": true,
            "data": {
                "table": []
            }
        };
}

//Get Ranking Ventas Por Mall
export const RankingVentasPorMall = async (args) => {
    let response;
    await (axios.get(PathNames.RankingVentasPorMall,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                inflacion: args.inflacion,
                diaMesInicio: args.diaMesInicio,
                diaMesFin: args.diaMesFin,
                anio1: args.anio1,
                anio2: args.anio2,
                token: args.token
            },

            headers: { 'Authorization': `Bearer ${args.token}` }
        }

    ).then(res => response = res.data));
    if (response.data)
        return parcharTabla(response);
    else
        return {
            "errorId": null,
            "message": "Acción ejecutada satisfactoriamente.",
            "success": true,
            "data": {
                "table": []
            }
        };
}

//Get Ventas Por Categoría
export const VentasPorCategoria = async (args) => {
    let response;
    await (axios.get(PathNames.VentasPorCategoria,
        {
            params: {
                tipo: args.tipo,
                unidadEconomicaId: args.unidadEconomicaId,
                inflacion: args.inflacion,
                diaMesInicio: args.diaMesInicio,
                diaMesFin: args.diaMesFin,
                anio1: args.anio1,
                anio2: args.anio2,
                token: args.token,
                rubro: args.rubro,
                cebe: args.cebe
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    if (response.data)
        return parcharTabla(response);
    else
        return {
            "errorId": null,
            "message": "Acción ejecutada satisfactoriamente.",
            "success": true,
            "data": {
                "table": []
            }
        };
}




//Get Reporte General Ventas
export const VentasGeneral = async (args) => {
    let response;
    await (axios.get(PathNames.VentasGeneral,
        {
            params: {
                fechaInicio: args.fechaInicio,
                fechaFin: args.fechaFin,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}


//Get Reporte General Ventas Prsupuesto RubroList
export const VentasGeneralPresupuesto_RubroList = async (args) => {
    let response;
    await (axios.get(PathNames.VentasGeneralPresupuesto_RubroList,
        {
            params: {
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}
//Get Reporte General Ventas Prsupuesto
export const VentasGeneralPresupuesto = async (args) => {
    let response;
    await (axios.get(PathNames.VentasGeneralPresupuesto,
        {
            params: {
                // rubroId: args.rubroId,
                unidadEconomicaId: args.unidadEconomicaId,
                inflacion: args.inflacion,
                mes: args.mes,
                anio1: args.anio1,
                anio2: args.anio2,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}


//Get Reporte General Ventas Prsupuesto
export const VentasDiarias = async (args) => {
    let response;
    await (axios.get(PathNames.VentasDiarias,
        {
            params: {
                fechaCorte: args.fechaCorte,
                token: args.token,
                tipoVenta: args.tipoVenta,
                unidadEconomicaId: args.unidadEconomicaId,
                // tipoClasificacion: args.tipoClasificacion,
                inflacion: args.inflacion
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get Reporte Ranking Ventas Mensual
export const RankingVentasMensual = async (args) => {
    let response;
    await (axios.get(PathNames.RankingVentasMensual,
        {
            params: {
                anio: args.anio,
                mes: args.mes,
                token: args.token,
                rubroId: args.rubroId,
                unidadEconomicaId: args.unidadEconomica
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return parcharTabla(response);
}

//Get Reporte Ranking Ventas Anual
export const RankingVentasAnual = async (args) => {
    let response;
    await (axios.get(PathNames.RankingVentasAnual,
        {
            params: {
                anio: args.anio,
                token: args.token,
                rubroId: args.rubroId,
                unidadEconomicaId: args.unidadEconomica
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return parcharTabla(response);
}

//Get Reporte Ranking Ventas Anual M2
export const RankingVentasAnualM2 = async (args) => {
    let response;
    await (axios.get(PathNames.RankingVentasAnualM2,
        {
            params: {
                anio: args.anio,
                token: args.token,
                rubroId: args.rubroId,
                unidadEconomicaId: args.unidadEconomica
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return parcharTabla(response);
}

//Get Crecimiento Mensual
export const CrecimientoMensual = async (args) => {
    let response;
    await (axios.get(PathNames.CrecimientoMensual,
        {
            params: {
                fecha: args.fecha,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get Ventas M2 Locatario
export const VentasM2Locatario = async (args) => {
    let response;
    await (axios.get(PathNames.VentasM2Locatario,
        {
            params: {
                fechaInicio: args.fechaInicio,
                fechaFin: args.fechaFin,
                unidadEconomicaId: args.unidadEconomicaId,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return parcharTabla(response);
}

//Get Provision Ventas
export const ProvisionVentas = async (args) => {
    let response;
    await (axios.get(PathNames.ProvisionVentas,
        {
            params: {
                anio: args.anio,
                mes: args.mes,
                unidadEconomicaId: args.unidadEconomicaId,
                codigoContratoId: args.codigoContratoId,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get Flash Semanal
export const FlashSemanal = async (args) => {
    let response;
    await (axios.get(PathNames.FlashSemanal,
        {
            params: {
                fechaInicio: args.fechaInicio,
                fechaFin: args.fechaFin,
                unidadEconomicaId: args.unidadEconomicaId,
                codigoContratoId: args.codigoContratoId,
                // grupoId: args.grupoId,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return parcharTabla(response);
}

//Get Indicadores Venta Mes
export const IndicadoresVentasMes = async (args) => {
    let response;
    await (axios.get(PathNames.IndicadoresVentasMes,
        {
            params: {
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}
//Get Indicadores Venta Mes Rubros
export const IndicadoresVentasMesRubros = async (args) => {
    let response;
    await (axios.get(PathNames.IndicadoresVentasMesRubros,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}
//Get Indicadores Lista Contratos Mes
export const IndicadoresListaContratosMes = async (args) => {
    let response;
    await (axios.get(PathNames.IndicadoresListaContratosMes,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                token: args.token,
                rubroId: args.rubroId
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}
//Get Comparativa Venta Anual
export const IndicadoresComparativaVentaAnual = async (args) => {
    let response;
    await (axios.get(PathNames.IndicadoresComparativaVentaAnual,
        {
            params: {
                rubroId: args.rubroId,
                token: args.token,
                anioComparativo: args.anioComparativo
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get Indicadores Venta Mes M2
export const IndicadoresVentasMesM2 = async (args) => {
    let response;
    await (axios.get(PathNames.IndicadoresVentasMesM2,
        {
            params: {
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}
//Get Indicadores Venta Mes M2 Rubros 
export const IndicadoresVentasMesM2Rubros = async (args) => {
    let response;
    await (axios.get(PathNames.IndicadoresVentasMesM2Rubros,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}
//Get Indicadores Lista Contratos Mes M2
export const IndicadoresListaContratosMesM2 = async (args) => {
    let response;
    await (axios.get(PathNames.IndicadoresListaContratosMesM2,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                rubroId: args.rubroId,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}
//Get Comparativa Venta Anual M2
export const IndicadoresComparativaVentaAnualM2 = async (args) => {
    let response;
    await (axios.get(PathNames.IndicadoresComparativaVentaAnualM2,
        {
            params: {
                rubroId: args.rubroId,
                token: args.token,
                anioComparativo: args.anioComparativo
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}
export const IndicadoresComparativaMesCerrado = async (args) => {
    let response;
    await (axios.get(PathNames.IndicadoresComparativaMesCerrado,
        {
            params: {
                rubroId: args.rubroId,
                token: args.token,
                anioComparativo: args.anioComparativo
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get Indicadores Venta Mes Cerrado
export const IndicadoresVentasMesCerrado = async (args) => {
    let response;
    await (axios.get(PathNames.IndicadoresVentasMesCerrado,
        {
            params: {
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}
//Get Indicadores Venta Mes Cerrado Rubros 
export const IndicadoresVentasMesCerradoRubros = async (args) => {
    let response;
    await (axios.get(PathNames.IndicadoresVentasMesCerradoRubros,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}
//Get Indicadores Lista Contratos Mes Cerrado
export const IndicadoresListaContratosMesCerrado = async (args) => {
    let response;
    await (axios.get(PathNames.IndicadoresListaContratosMesCerrado,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                rubroId: args.rubroId,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get Indicadores Venta General Mes
export const IndicadoresVentaGeneralMes = async (args) => {
    let response;
    await (axios.get(PathNames.IndicadoresVentaGeneralMes,
        {
            params: {
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}
//Get Indicadores Venta General Mes M2
export const IndicadoresVentaGeneralMesM2 = async (args) => {
    let response;
    await (axios.get(PathNames.IndicadoresVentaGeneralMesM2,
        {
            params: {
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get Grafica Ventas Totales Mes
export const GraficaVentasTotalesMes = async (args) => {
    let response;
    await (axios.get(PathNames.GraficaVentasTotalesMes,
        {
            params: {
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}
//Get Grafica Ventas Totales Mes M2
export const GraficaVentasTotalesMesM2 = async (args) => {
    let response;
    await (axios.get(PathNames.GraficaVentasTotalesMesM2,
        {
            params: {
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get Lista de Contratos
export const ListaContratos = async (args) => {
    let response;
    await (axios.get(PathNames.ListaContratos,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}
//Get Actualizar Fecha de Contratos
export const ActualizarFechaContratos = async (args) => {
    let response;
    await (axios.post(PathNames.ActualizarFechaContratos +
        `?codContrato=${args.codContrato}&fechaInicioOperaciones=${args.fechaInicioOperaciones}&fechaFinOperaciones=${args.fechaFinOperaciones}`
    ).then(res => response = res.data));
    return response;
}


//Get Mapa Calor Vacancy List
export const MapaCalorVacancyList = async (args) => {
    let response;
    await (axios.get(PathNames.MapaCalorVacancyList,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get Mapa Calor Vacancy Change Status
export const MapaCalorVacancyChangeStatus = async (args) => {
    let response;
    await (axios.post(PathNames.MapaCalorVacancyChangeStatus +
        `?unidadEconomicaId=${args.unidadEconomicaId}&idObj=${args.idObj}&newStatus=${args.idNewStatus}`
    ).then(res => response = res.data));
    return response;
}

//Get Mapa Calor Get Vacancy
export const MapaCalorVacancyGetVacancy = async (args) => {
    let response;
    await (axios.get(PathNames.MapaCalorVacancyGetVacancy,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get Mapa Calor All_in
export const MapaCalorAllin = async (args) => {
    let response;
    await (axios.get(PathNames.MapaCalorAllin,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                mes: args.mes,
                anio1: args.anio1,
                anio2: args.anio2,
                categoriaId: args.categoria,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response?.data ? response : null;
}

//Get Mapa Mapa Calor All In CategoryList
export const MapaCalorAllIn_CategoryList = async (args) => {
    let response;
    await (axios.get(PathNames.MapaCalorAllIn_CategoryList,
        {
            params: {
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));

    let responseFinal = {
        "success": true,
        "message": 'Acción ejecutada satisfactoriamente.',
        "data": null,
        "errorId": null
    };
    if (args.type == "list") {
        responseFinal.data =
        {
            "defaultId": response.data ? response.data.length > 0 ? response.data[0].value : null : null,
            "list": response.data
        }
    }
    if (args.type == "table") {
        responseFinal.success = response.success;
        responseFinal.message = response.message;
        responseFinal.errorId = response.errorId;
        responseFinal.data = {
            "auxData": null, "table": response.data
        }
    }
    return responseFinal;
}


//Get MapaCalorAllIn_removeCategory
export const MapaCalorAllIn_RemoveCategory = async (args) => {
    let response;

    await (axios.post(PathNames.MapaCalorAllIn_RemoveCategory + `?categoriaId=${args.category}`,
        {
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    // response = {
    //     "success": true,
    //     "message": "Acción ejecutada satisfactoriamente.",
    //     "data": null,
    //     "errorId": null
    // }
    return response;
}

//Get MapaCalorAllIn_AddCategory
export const MapaCalorAllIn_AddCategory = async (args) => {
    let response;

    let params = new URLSearchParams({
        categoriaName: args.newCategoria.nombre,
        verdeDesde: args.newCategoria.verdeMin,
        verdeHasta: args.newCategoria.verdeMax,
        amarilloDesde: args.newCategoria.amarilloMin,
        amarilloHasta: args.newCategoria.amarilloMax,
        rojoDesde: args.newCategoria.rojoMin,
        rojoHasta: args.newCategoria.rojoMax,
        token: args.token
    }).toString();

    await (axios.post(PathNames.MapaCalorAllIn_AddCategory + '?' + params,
        {
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));

    return response;
}

//Get MapaCalorAllIn_EditCategory
export const MapaCalorAllIn_EditCategory = async (args) => {
    let response;
    let params = new URLSearchParams({
        categoriaId: args.newCategoria.categoriaId,
        categoriaName: args.newCategoria.nombre,
        verdeDesde: args.newCategoria.verdeMin,
        verdeHasta: args.newCategoria.verdeMax,
        amarilloDesde: args.newCategoria.amarilloMin,
        amarilloHasta: args.newCategoria.amarilloMax,
        rojoDesde: args.newCategoria.rojoMin,
        rojoHasta: args.newCategoria.rojoMax,
        token: args.token
    }).toString();

    await (axios.post(PathNames.MapaCalorAllIn_EditCategory + '?' + params,
        {
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));

    return response;
}


//Get Mapa Calor VistaGeneral_IndicadorVentas
export const MapaCalorVistaGeneral_IndicadorVentas = async (args) => {
    let response;
    await (axios.get(PathNames.MapaCalorVistaGeneral_IndicadorVentas,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}


//Get Mapa Calor VistaGeneral_ReporteCierre
export const MapaCalorVistaGeneral_ReporteCierre = async (args) => {
    let response;
    await (axios.get(PathNames.MapaCalorVistaGeneral_ReporteCierre,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get Mapa Calor Mantenimiento
export const MapaCalorMantenimiento = async (args) => {
    let response;
    await (axios.get(PathNames.MapaCalorMantenimiento,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get mapaMantenimiento_ListaContratos
export const MapaMantenimiento_ListaContratos = async (args) => {
    let response;
    await (axios.get(PathNames.MapaMantenimiento_ListaContratos,
        {
            params: {
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get Mapa Calor Mantenimiento Guardar
export const MapaCalorMantenimiento_guardarContrato = async (args) => {
    let response;
    await (axios.post(PathNames.MapaCalorMantenimiento_guardarContrato +
        `?unidadEconomicaId=${args.unidadEconomicaId}&idObj=${args.idObj}&numContrato=${args.contrato}&local=${args.local}`
    ).then(res => response = res.data));
    return response;
}



//Get AfluenciaDiariaPeatonal
export const AfluenciaDiariaPeatonal = async (args) => {
    let response;
    await (axios.get(PathNames.AfluenciaDiariaPeatonal,
        {
            params: {
                mes: args.mes,
                anio1: args.anio1,
                anio2: args.anio2,
                unidadEconomicaId: args.unidadEconomica,
                quincena: args.numero,
                zona: args.zona,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    if (response.data.length === 0) response.data = null;

    return response;
}

//Get AfluenciaMensualPeatonal
export const AfluenciaMensualPeatonal = async (args) => {
    let response;
    await (axios.get(PathNames.AfluenciaMensualPeatonal,
        {
            params: {
                anio1: args.anio1,
                anio2: args.anio2,
                unidadEconomicaId: args.unidadEconomica,
                zona: args.zona,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}


//Get AfluenciaDiariaParking
export const AfluenciaDiariaParking = async (args) => {
    let response;
    await (axios.get(PathNames.AfluenciaDiariaParking,
        {
            params: {
                mes: args.mes,
                anio1: args.anio1,
                anio2: args.anio2,
                unidadEconomicaId: args.unidadEconomica,
                quincena: args.numero,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    if (response.data.length == 0) response.data = null;
    return response;
}

//Get AfluenciaMensualParking
export const AfluenciaMensualParking = async (args) => {
    let response;
    await (axios.get(PathNames.AfluenciaMensualParking,
        {
            params: {
                anio1: args.anio1,
                anio2: args.anio2,
                unidadEconomicaId: args.unidadEconomica,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get ListaRoja
export const ListaRoja = async (args) => {
    let response;
    await (axios.get(PathNames.ListaRoja,
        {
            params: {
                codigoContratoId: args.codigoContratoId,
                unidadEconomicaId: args.unidadEconomicaId,
                cebeId: args.cebe,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get GetInflacionxAño
export const GetInflacion_Anio = async (args) => {
    let response;
    await (axios.get(PathNames.GetInflacion_Anio,
        {
            params: {
                anio: args.anio,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get SetInflacionxAño
export const SetInflacion_Anio = async (args) => {
    let response;

    let params = new URLSearchParams({
        anio: args.anio,
        enero: args.enero,
        febrero: args.febrero,
        marzo: args.marzo,
        abril: args.abril,
        mayo: args.mayo,
        junio: args.junio,
        julio: args.julio,
        agosto: args.agosto,
        setiembre: args.setiembre,
        octubre: args.octubre,
        noviembre: args.noviembre,
        diciembre: args.diciembre,
        token: args.token
    }).toString();

    await (axios.post(PathNames.SetInflacion_Anio + '?' + params,
        {
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));

    return response;
}

//Get GetBloquearCierre
export const GetBloquearCierre = async (args) => {
    let response;
    await (axios.get(PathNames.GetBloquearCierre,
        {
            params: {
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get SetBloquearCierre
export const SetBloquearCierre = async (args) => {
    let response;

    let params = new URLSearchParams({
        bloquearCierre: true,
        fecha: args.dateFormated,
        token: args.token
    }).toString();

    await (axios.post(PathNames.SetBloquearCierre + '?' + params,
        {
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}


//Get ListaLocatarios
export const ListaLocatarios = async (args) => {
    let response;
    await (axios.get(PathNames.ListaLocatarios,
        {
            params: {
                unidadEconomicaId: args.unidadEconomicaId,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}
//Get ClasificacionComercial
export const ClasificacionComercial = async (args) => {
    let response;
    await (axios.get(PathNames.ClasificacionComercial,
        {
            params: {
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}
//Get ClasificacionSubComercial
export const ClasificacionSubComercial = async (args) => {
    let response;
    await (axios.get(PathNames.ClasificacionSubComercial,
        {
            params: {
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get GetDataLocatario
export const GetDataLocatario = async (args) => {
    let response;
    await (axios.get(PathNames.GetDataLocatario,
        {
            params: {
                numContrato: args.numContrato,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get ActualizarLocatario
export const ActualizarLocatario = async (args) => {
    let response;

    let params = new URLSearchParams({
        numContrato: args.numContrato,
        operador_correo: args.operador_correo,
        operador_nombre: args.operador_nombre,
        operador_contrasenia: args.operador_contrasenia,
        administrador_correo: args.administrador_correo,
        administrador_nombre: args.administrador_nombre,
        administrador_contrasenia: args.administrador_contrasenia,

        financiero1_correo: args.financiero1_correo,
        financiero1_contrasenia: args.financiero1_contrasenia,
        financiero1_nombre: args.financiero1_nombre,
        financiero2_correo: args.financiero2_correo,
        financiero2_contrasenia: args.financiero2_contrasenia,
        financiero2_nombre: args.financiero2_nombre,

        clasificacionComercialId: args.clasificacionComercialId,
        clasificacionSubComercialId: args.clasificacionSubComercialId,
        categoriaId: args.categoriaId
    }).toString();

    await (axios.post(PathNames.ActualizarLocatario + '?' + params, {},
        {
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get CierreVentasPorLocatario
export const CierreVentasPorLocatario = async (args) => {
    let response;
    await (axios.get(PathNames.CierreVentasPorLocatario,
        {
            params: {
                numContrato: args.numContrato,
                fechaInicial: args.fechaInicial,
                fechaFinal: args.fechaFinal,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get ActualizarCierreVentas
export const ActualizarCierreVentas = async (args) => {
    let response;
    await (axios.post(PathNames.ActualizarCierreVentas +
        `?cierreVentaId=${args.cierreVentaId}&ventasValor=${args.ventasValor}&numeroTransacciones=${args.numeroTransacciones}`
    ).then(res => response = res.data));
    return response;
}

//Get EstadosCuentaLista
export const EstadosCuentaLista = async (args) => {
    let response;
    await (axios.get(PathNames.EstadosCuentaLista,
        {
            params: {
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get DetalleEstadoCuenta
export const DetalleEstadoCuenta = async (args) => {
    let response;
    await (axios.get(PathNames.DetalleEstadoCuenta,
        {
            params: {
                ruc: args.ruc,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get GetCuentasRecaudadoras
export const GetCuentasRecaudadoras = async (args) => {
    let response;
    await (axios.get(PathNames.GetCuentasRecaudadoras,
        {
            params: {
                ruc: args.ruc,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get GetlistaCobranzaIndicadores
export const GetlistaCobranzaIndicadores = async (args) => {
    let response;
    await (axios.get(PathNames.GetlistaCobranzaIndicadores,
        {
            params: {
                ruc: args.ruc,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get GetlistaDeudasVencidas
export const GetlistaDeudasVencidas = async (args) => {
    let response;
    await (axios.get(PathNames.GetlistaDeudasVencidas,
        {
            params: {
                ruc: args.ruc,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get GetDetalleDeuda
export const GetDetalleDeuda = async (args) => {
    let response;
    await (axios.get(PathNames.GetDetalleDeuda,
        {
            params: {
                idDeuda: args.idDeuda,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}


//Get TipoMotivo
export const TipoMotivoList = async (args) => {
    let response;
    await (axios.get(PathNames.TipoMotivoList,
        {
            params: {
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}
//Get Motivo
export const MotivosList = async (args) => {
    let response;
    await (axios.get(PathNames.MotivosList,
        {
            params: {
                tipoMotivo: args.tipoMotivo,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}
//Get ListaLocales
export const ListaLocales = async (args) => {
    let response;
    await (axios.get(`${PathNames.ListaLocales}?unidadEconomica=${args.unidadEconomica.value}`,
        {
            params: {
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get RegistrarAmonestacion
export const RegistrarAmonestacion = async (args) => {
    let response;

    let params = new URLSearchParams({
        "unidadEconomica": args.unidadEconomica,
        "idLocatario": args.locatarioId,
        "tipoMotivo": args.tipoMotivo,
        "motivo": args.motivo,
        "responsable": args.responsable,
        "dni": args.dni,
        "detalle": args.detalle,
        "emailCopia": args.emailCopia || "",
        "tam": args.tam || 0,
        "montoPenalidad": args.montoPenalidad || 0,
        "treintavo": args.treintavo || 0,
        "diasPenalidad": args.diasPenalidad || 0,
        "montoFinal": args.montoFinal || 0
    }).toString();

    console.log(args.pictures[0]);
    const formData = new FormData();
    formData.append("file", args.pictures[0]);
    const config = {
        headers: {
            "content-type": "multipart/form-data",
            'Authorization': `Bearer ${args.token}`
        }
    };

    await (axios.post(PathNames.RegistrarAmonestacion + '?' + params + `&fecha=${args.fecha}&hora=${args.hora}&fechaInicio=${args.fechaInicio}&fechaFin=${args.fechaFin}&horaInicio=${args.horaInicio}&horaFin=${args.horaFin}`,
        formData, config
    ).then(res => response = res.data));
    console.log(response);
    return response;
}

//Get VistaAmonestacion
export const VistaAmonestacion = async (args) => {
    let response;
    await (axios.get(PathNames.VistaAmonestacion,
        {
            params: {
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return parcharTabla(response);
}

//Get VistaAmonestacionOperaciones (Amonestaciones aprobadas por operaciones)
export const VistaAmonestacionOperaciones = async (args) => {
    let response;
    await (axios.get(PathNames.VistaAmonestacion,
        {
            params: {
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));

    if (response && response.data && Array.isArray(response.data)) {
        response.data = response.data.filter(item => item.aprobacion_operaciones === true || item.aprobacion_operaciones === 1 || item.aprobacion_operaciones === 'true');
    }
    return parcharTabla(response);
}
//Get RegistrarAprobacionDesaprobacionAmonestacion
export const RegistrarAprobacionDesaprobacionAmonestacion = async (args) => {
    let response;

    let params = new URLSearchParams({
        idAmonestacion: args.idAmonestacion,
        accion: args.apruebaDesaprueba,
        observacion: args.observacionCurrentEdit,
        role: args.observadorRole,
        descuentoPorcentaje: args.descuentoPorcentaje || 0,
    }).toString();

    await (axios.post(PathNames.RegistrarAprobacionDesaprobacionAmonestacion + '?' + params,
        {
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));

    return response;
}

//Get BitacoraDiaraVentas
export const BitacoraDiariaVentas = async (args) => {
    let response;
    await (axios.get(PathNames.BitacoraDiariaVentas,
        {
            params: {
                unidadEconomicaId: args.unidadEconomica,
                fechaInicio: args.fechaInicio,
                fechaFin: args.fechaFin,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get BitacoraEvento_Agregar
export const BitacoraEvento_Agregar = async (args) => {
    let response;
    await (axios.post(PathNames.BitacoraEvento_Agregar +
        `?fecha=${args.date}
    &evento=${args.eventName}&unidadEconomicaId=${args.unidadEconomicaId}`).then(res => response = res.data));
    return response;
}





//Get DashboardIndicadoresVentas
export const DashboardIndicadoresVentas = async (args) => {
    let response;
    await (axios.get(PathNames.DashboardIndicadoresVentas,
        {
            params: {
                idLocatario: args.idLocatario,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//Get VentasToatalesxMes
export const DashboardVentasTotalesxMes = async (args) => {
    let response;
    await (axios.get(PathNames.DashboardVentasTotalesxMes,
        {
            params: {
                idLocatario: args.idLocatario,
                anio1: args.anio1,
                anio2: args.anio2,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}
//Get VentasToatalesxMes
export const DashboardPromedioRubroXMesVsTotales = async (args) => {
    let response;
    await (axios.get(PathNames.DashboardPromedioRubroXMesVsTotales,
        {
            params: {
                idLocatario: args.idLocatario,
                anio: args.anio,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}
//Get CierreVentas_Locatario
export const CierreVentas_Locatario = async (args) => {
    let response;
    await (axios.get(PathNames.CierreVentas_Locatario,
        {
            params: {
                idLocatario: args.idLocatario,
                fechaInicial: args.fechaInicial,
                fechaFinal: args.fechaFinal,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return parcharTabla(response);
}
//POST ActualizarCierreVentas_Locatario
export const ActualizarCierreVentas_Locatario = async (args) => {
    let response;
    await (
        axios.post(
            PathNames.ActualizarCierreVentas_Locatario + `?idLocatario=${args.idLocatario}&cierreVentaId=${args.cierreVentaId}&ventasValor=${args.ventasValor}&numeroTransacciones=${args.numeroTransacciones}`
        ).then(res => response = res.data));
    return response;
}

//Get ActualizarCierreVentas_Locatario
export const GetRegistrarCierreVentas_Locatario = async (args) => {
    let response;
    await (axios.get(PathNames.GetRegistrarCierreVentas_Locatario,
        {
            params: {
                idLocatario: args.idLocatario,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

//SetActualizarCierreVentas_Locatario
export const SetRegistrarCierreVentas_Locatario = async (args) => {
    let response;

    let postUrl = PathNames.SetRegistrarCierreVentas_Locatario + `?idLocatario=${args.idLocatario}&fechaRegistro=${args.dataSetRegistrar.fechaRegistro}`;

    await (axios.post(postUrl,

        args.dataSetRegistrar.suministros,

        {
            headers: { 'Authorization': `Bearer ${args.token}` },
        }
    )).then(res => response = res.data);
    return response;
}

//Get GetUsuarios_Locatario
export const GetUsuarios_Locatario = async (args) => {
    let response;
    await (axios.get(PathNames.GetUsuarios_Locatario,
        {
            params: {
                idLocatario: args.idLocatario,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}



//Get SetUsuarios_Locatario
export const SetUsuarios_Locatario = async (args) => {
    let response;
    let postUrl = PathNames.SetUsuarios_Locatario +
        `?idLocatario=${args.idLocatario}` +
        `&administrador_correo=${args.dataUsuarios.administrador.correo}` +
        `&administrador_nombreCompleto=${args.dataUsuarios.administrador.nombreCompleto}` +
        `&administrador_contrasenia=${args.dataUsuarios.administrador.contrasenia}` +
        `&operador_correo=${args.dataUsuarios.operador.correo}` +
        `&operador_nombreCompleto=${args.dataUsuarios.operador.nombreCompleto}` +
        `&operador_contrasenia=${args.dataUsuarios.operador.contrasenia}` +
        `&financiero1_correo=${args.dataUsuarios.financiero1.correo}` +
        `&financiero1_nombreCompleto=${args.dataUsuarios.financiero1.nombreCompleto}` +
        `&financiero1_contrasenia=${args.dataUsuarios.financiero1.contrasenia}` +
        `&financiero2_correo=${args.dataUsuarios.financiero2.correo}` +
        `&financiero2_nombreCompleto=${args.dataUsuarios.financiero2.nombreCompleto}` +
        `&financiero2_contrasenia=${args.dataUsuarios.financiero2.contrasenia}`;

    await (axios.post(postUrl).then(res => response = res.data));
    return response;
}

//Get DetalleEstadoCuenta_Locatario
export const DetalleEstadoCuenta_Locatario = async (args) => {
    let response;
    await (axios.get(PathNames.DetalleEstadoCuenta_Locatario,
        {
            params: {
                idLocatario: args.idLocatario,
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}


//Get GetNotifications
export const GetNotifications = async (args) => {
    let response;
    await (axios.get(PathNames.GetNotifications,
        {
            params: {
                token: args.token
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }).then(res => response = res.data));

    if (response.data)
        return {
            "success": true,
            "message": "Acción ejecutada satisfactoriamente.",
            "errorId": null,
            "data": response.data?.filter((typeNotification) => typeNotification.notificaciones.length > 0)
        }
    else return response;


}



export const GetDni = async (args) => {
    let response;
    await (axios.get(`${PathNames.GetDni}?email=${args.email}`,
        {
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data))
    return response
}

export const GetRuc = async (args) => {
    let response;
    await (axios.get(`${PathNames.GetRuc}?idLocatario=${args.idLocatario}`,
        {
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data))
    return response
}

export const ListaRubro = async (args) => {
    try {
        const response = await axios.get(
            PathNames.ListaRubro,
            {
                headers: { 'Authorization': `Bearer ${args.token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const ListaCebe = async (args) => {
    try {
        const response = await axios.get(
            `${PathNames.ListaCebe}?idUnidadEconomica=${args.unidadEconomicaId}`,
            {
                headers: { 'Authorization': `Bearer ${args.token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetGarantiasByRuc = async (ruc) => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetGarantiasByRuc(ruc),
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetGarantiasByRucContrato = async (ruc, nroContrato) => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetGarantiasByRucContrato(ruc, nroContrato),
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetDetalleGarantiasListToRevision = async () => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetDetalleGarantiasListToRevision,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetDetalleGarantiasListFullWithFilter = async (request) => {
    const token = useGetToken();
    try {

        const response = await axios.post(
            PathNames.GetDetalleGarantiasListFullWithFilter,
            request,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}


//@JD
export const GetDetalleGarantiasListToRevision2 = async () => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetDetalleGarantiasListToRevision2,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetDetalleGarantiasListFullWithFilter2 = async (request) => {
    const token = useGetToken();
    try {

        const response = await axios.post(
            PathNames.GetDetalleGarantiasListFullWithFilter2,
            request,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}


export const GetGarantiasToRecepcion = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.GetGarantiasToRecepcion,
            obj,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetAllGarantiaRecepcion = async () => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetAllGarantiaRecepcion,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}


export const GetRecepciones = async (args) => {
    // let response = await (axios.get(`https://mallaventuraservicesdev.azurewebsites.net/api/garantias/${args.idGarantia}/recepciones`,
    let response = await (axios.get(`https://mallaventuraservicesdev.azurewebsites.net/api/garantias/384/recepciones`,
        {
            headers: {
                "Ocp-Apim-Subscription-Key": "b88e914fb24f4fea9ec8492845dbf352"
            }
        }
    ))
    return response.data
}

export const GetAllGarantias = async (args) => {
    let response = await (axios.get(`${PathNames.apiUrl}garantias/all`,
        {
            headers: {
                "Ocp-Apim-Subscription-Key": "b88e914fb24f4fea9ec8492845dbf352"
            }
        }
    ))
    return response.data
}

//TODO: TO_DELETE
// export const GetGarantiasByRequerimiento = async (args) => {
//     let response = await (axios.get(`${PathNames.apiUrl}garantias/all_by_requerimiento`,
//         {
//             headers: {
//                 "Ocp-Apim-Subscription-Key": "b88e914fb24f4fea9ec8492845dbf352"
//             }
//         }
//     ))
//     return response.data
// }

//Garantias Locatario
export const GetMallList = async () => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetMallList,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetBancoListByLevel = async (id) => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetBancoListByLevel(id),
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetBancoListHabilitadosxCartaFianza = async () => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetBancoListHabilitadoxCartaFianza,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetBancoListHabilitadosxOperacionEfectivo = async () => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetBancoListHabilitadoxOperacionEfectivo,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const SaveBanco = async (bancoObj) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.SaveBanco,
            bancoObj,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
}


export const GetMonedaList = async () => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetMonedaList,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetGarantiaById = async (id) => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetGarantiaById(id),
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}


export const GetDetalleGarantiaLocatario = async (idDetalleGarantia) => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetDetalleGarantiaLocatario(idDetalleGarantia),
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}


export const GetGarantiaFullById = async (id) => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetGarantiaFullById(id),
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetRecepcionesByGarantiaId = async (idGarantia) => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetRecepcionesByGarantiaId(idGarantia),
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}


export const GetEstadosRecepcionByTipoGarantia = async (codigoTipoGarantia) => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetEstadosRecepcionByTipoGarantia(codigoTipoGarantia),
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const SaveGarantiaRecepcion = async (idGarantiaDetalle, idRecepcionEstado, fechaIngreso, updatedBy) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.SaveGarantiaRecepcion(),
            {
                "id_garantia_detalle": idGarantiaDetalle,
                "id_garantia_recepcion_estado": idRecepcionEstado,
                "fecha_ingreso_cuenta": fechaIngreso,
                "updated_by": updatedBy
            },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const ValidationGarantiaLocatario = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.ValidationGarantiaLocatario,
            obj,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        )
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const SaveDetalleGarantia = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.put(
            PathNames.SaveDetalleGarantia,
            obj,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        )
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const UpdateEstadoDetalleGarantia = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.put(
            PathNames.UpdateEstadoDetalleGarantia,
            obj,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        )
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const UploadAdjuntoDetalleGarantia = async (formData, id) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.UploadAdjuntoDetalleGarantia(id),
            formData,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        )
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const UploadAdjuntoDetalleGarantiaExcepcion = async (formData, id, updatedBy) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.UploadAdjuntoDetalleGarantiaExcepcion(id, updatedBy),
            formData,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        )
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const GetCierreMes = async (args) => {
    try {
        const response = await axios.get(`${PathNames.GetCierreMes}?cierreMes=${args.cierreMes}`,
            {
                headers: { 'Authorization': `Bearer ${args.token}` }
            }
        )
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const SaveCierreMes = async (args) => {
    try {
        const response = await axios.get(`${PathNames.SaveCierreMes}?cierreMes=${args.cierreMes}&status=${Boolean(args.status)}`,
            {
                headers: { 'Authorization': `Bearer ${args.token}` }
            }
        )
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const GetAnioComparativo = async (args) => {
    try {
        const response = await axios.get(PathNames.GetAnioComparativo, {
            headers: { 'Authorization': `Bearer ${args.token}` }
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const SaveAnioComparativo = async (args) => {
    try {
        const response = await axios.get(`${PathNames.SaveAnioComparativo}?anioComparativo=${args.date}`,
            {
                headers: { 'Authorization': `Bearer ${args.token}` }
            }
        )
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const GetMantenimientoTiendas = async (args) => {
    try {
        const response = await axios.get(PathNames.GetMantenimientoTiendas, {
            headers: { 'Authorization': `Bearer ${args.token}` }
        })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const SaveMantenimientoTiendas = async (args) => {
    try {
        let contratos = {
            contratoArequipa: (args.contratos.arequipa) ? args.contratos.arequipa : '',
            contratoSantaAnita: (args.contratos.santaAnita) ? args.contratos.santaAnita : '',
            contratoChiclayo: (args.contratos.chiclayo) ? args.contratos.chiclayo : '',
            contratoIquitos: (args.contratos.iquitos) ? args.contratos.iquitos : '',
            contratoSjl: (args.contratos.sjl) ? args.contratos.sjl : ''
        }
        const response = await axios.get(PathNames.SaveMantenimientoTiendas,
            {
                params: contratos
            },
            {
                headers: { 'Authorization': `Bearer ${args.token}` }
            })
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const EditMantenimientoTiendas = async (args) => {
    try {
        let contratos = {
            id: args.id,
            contratoArequipa: (args.contratos.arequipa) ? args.contratos.arequipa : '',
            contratoSantaAnita: (args.contratos.santaAnita) ? args.contratos.santaAnita : '',
            contratoChiclayo: (args.contratos.chiclayo) ? args.contratos.chiclayo : '',
            contratoIquitos: (args.contratos.iquitos) ? args.contratos.iquitos : '',
            contratoSjl: (args.contratos.sjl) ? args.contratos.sjl : ''
        }
        const response = await axios.get(PathNames.EditMantenimientoTiendas,
            {
                params: contratos
            },
            {
                headers: { 'Authorization': `Bearer ${args.token}` }
            })
        return response.data
    } catch (error) {
        console.log(error)
    }
}



export const AddCartaFianza = async (idGarantia, updatedBy) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.AddCartaFianza(),
            {
                "id_garantia": idGarantia,
                "updated_by": updatedBy
            },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const SaveRevisionGarantiaDetalle = async (idDetalleGarantia, revisiones, observaciones, rolRevisor, usuariorevisor) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.SaveRevisionGarantiaDetalle,
            {
                "id_detalle_garantia": idDetalleGarantia,
                "revisiones": revisiones,
                "observaciones": observaciones,
                "rol_revisor": rolRevisor,
                "usuario_revisor": usuariorevisor
            },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetCartasFianzaByVencer = async () => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetCartasFianzaByVencer,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const UploadAdjuntoRequerimiento = async (formData) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.UploadAdjuntoRequerimiento,
            formData,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        )
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const GetCartasNotarales = async () => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetCartasNotarales,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetConfigurationGenerationCartaNotarial = async () => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetConfigurationGenerationCartaNotarial,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const SaveConfigurationGenerationCartaNotarial = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.put(
            PathNames.SaveConfigurationGenerationCartaNotarial,
            obj,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        )
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const GenerationCartasNotariales = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.GenerationCartasNotariales,
            obj,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        )
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const CreateRequerimientoCartaFianza = async (idGarantiaDetalle, updatedBy) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.CreateRequerimientoCartaFianza,
            {
                "id_garantia_detalle": idGarantiaDetalle,
                "updated_by": updatedBy
            },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetDataToCarta = async (idBanco, idMall, idRequerimientoList) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.GetDataToCarta,
            {
                "id_banco": idBanco,
                "id_mall": idMall,
                "requerimientos": idRequerimientoList
            },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GenerarCartaRequerimiento = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.GenerarCartaRequerimiento,
            obj,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const DeleteRequerimiento = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.delete(
            PathNames.DeleteRequerimiento,
            {
                headers: { 'Authorization': `Bearer ${token}` },
                data: obj
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const CreateRenovacionCartaFianza = async (idGarantiaDetalle, updatedBy) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.CreateRenovacionCartaFianza,
            {
                "id_garantia_detalle": idGarantiaDetalle,
                "updated_by": updatedBy
            },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GeneracionCartaDesistimiento = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.GeneracionCartaDesistimiento,
            obj,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GeneracionProrroga = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.GeneracionProrroga,
            obj,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GeneracionCartaEjecucion = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.GeneracionCartaEjecucion,
            obj,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetGarantiasBovedaStateList = async () => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetGarantiasBovedaStateList,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetGarantiasBovedaAuthorizationList = async () => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetGarantiasBovedaAuthorizationList,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const SaveGarantiaBoveda = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.SaveGarantiaBoveda,
            obj,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetAllTiposExcepcion = async () => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetAllTiposExcepcion,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetTiposGarantiaList = async () => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetTiposGarantiaList,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetGarantiaDetalleFullById = async (id) => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetGarantiaDetalleFullById(id),
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const SaveFarantiaExcepcion = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.SaveFarantiaExcepcion,
            obj,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const UploadSustentoExcepcionGarantia = async (formData, id, updatedBy) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.UploadSustentoExcepcionGarantia(id, updatedBy),
            formData,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        )
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const DeleteExcepcion = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.delete(
            PathNames.DeleteExcepcion,
            {
                headers: { 'Authorization': `Bearer ${token}` },
                data: obj
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const ReportGarantiaPorVencimiento = async () => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.ReportGarantiaPorVencimiento,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}
export const ReportGradoDeAvance = async (id) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.ReportGradoDeAvance,
            {
                "id_mall": id
            },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetEstadosEntregaCarta = async () => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetEstadosEntregaCarta,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw new Error(error);
    }
}

export const SaveEntregaCartaRequerimiento = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.put(
            PathNames.SaveEntregaCartaRequerimiento,
            obj,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        )
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const SaveEntregaCartaDesistimiento = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.put(
            PathNames.SaveEntregaCartaDesistimiento,
            obj,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        )
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const SaveEntregaCartaEjecucion = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.put(
            PathNames.SaveEntregaCartaEjecucion,
            obj,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        )
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const SaveChequeEjecucion = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.put(
            PathNames.SaveChequeEjecucion,
            obj,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        )
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const ValidacionBancoEmail = async (id) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.ValidacionBancoEmail,
            {
                "id_garantia_detalle": id
            },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetMomentoEntrega = async () => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetMomentoEntrega,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw new Error(error);
    }
}

export const SaveMomentoEntrega = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.SaveMomentoEntrega,
            obj,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const UploadSustentoMomentoEntrega = async (formData, id, updatedBy) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.UploadSustentoMomentoEntrega(id, updatedBy),
            formData,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        )
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const GetGarantiasByEstadoCuenta = async (ruc) => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetGarantiasByEstadoCuenta(ruc),
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw new Error(error);
    }
}

export const UpdateGarantiaGeneralValue = async (codigo, value) => {
    const token = useGetToken();
    try {
        const response = await axios.put(
            PathNames.UpdateGarantiaGeneralValue,
            {
                "codigo": codigo,
                "value": value
            },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        )

        if (!response?.data.status) {
            console.error('Response status is false');
        }
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const GetGeneralValues = async () => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetGeneralValues,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw new Error(error);
    }
}

export const GetContratosList = async (email) => {
    //debugger;
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetContratoList(email),
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw new Error(error);
    }
}

export const ContratoList = async (args) => {
    let response;
    await (axios.get(PathNames.ContratoList,
        {
            params: {
                token: args.token,
                email: args.email
            },
            headers: { 'Authorization': `Bearer ${args.token}` }
        }
    ).then(res => response = res.data));
    return response;
}

export const GetDataInfoLocatario = async (idLocatario) => {
    //debugger;
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetDataInfoLocatario(idLocatario),
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw new Error(error);
    }
}

export const GetMantenimientoTiendasEx = async () => {
    //debugger;
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetMantenimientoTiendas,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw new Error(error);
    }
}

export const ListaLocalesEx = async (idUnidadEconomica) => {
    //debugger;
    const token = useGetToken();
    try {
        const response = await axios.get(
            `${PathNames.ListaLocales}?unidadEconomica=${idUnidadEconomica}`,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw new Error(error);
    }
}

export const EditMantenimientoTiendasEx = async (id, contratoArequipa, contratoSantaAnita, contratoChiclayo, contratoIquitos, contratoSjl) => {
    //debugger;
    const token = useGetToken();
    try {
        let contratos = {
            id: id,
            contratoArequipa: (contratoArequipa) ? contratoArequipa : '',
            contratoSantaAnita: (contratoSantaAnita) ? contratoSantaAnita : '',
            contratoChiclayo: (contratoChiclayo) ? contratoChiclayo : '',
            contratoIquitos: (contratoIquitos) ? contratoIquitos : '',
            contratoSjl: (contratoSjl) ? contratoSjl : ''
        }

        const response = await axios.post(
            PathNames.EditMantenimientoTiendas,
            contratos,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw new Error(error);
    }
}

export const SaveMantenimientoTiendasEx = async (contratoArequipa, contratoSantaAnita, contratoChiclayo, contratoIquitos, contratoSjl) => {
    //debugger;
    const token = useGetToken();
    try {
        let contratos = {
            contratoArequipa: (contratoArequipa) ? contratoArequipa : '',
            contratoSantaAnita: (contratoSantaAnita) ? contratoSantaAnita : '',
            contratoChiclayo: (contratoChiclayo) ? contratoChiclayo : '',
            contratoIquitos: (contratoIquitos) ? contratoIquitos : '',
            contratoSjl: (contratoSjl) ? contratoSjl : ''
        }

        const response = await axios.put(
            PathNames.SaveMantenimientoTiendas,
            contratos,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw new Error(error);
    }
}

export const DeleteContratoSimil = async (idContratoSimil) => {
    const token = useGetToken();
    try {
        const response = await axios.delete(
            PathNames.DeleteContratoSimil(idContratoSimil),
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const GetClienteGarantiaResumen = async () => {
    const token = useGetToken();
    try {
        const response = await axios.get(
            PathNames.GetClienteGarantiaResumen,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw new Error(error);
    }
}

export const GetClienteGarantiaData = async (ruc, nroContrato) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.GetClienteGarantiaData,
            {
                "ruc": ruc,
                "nro_contrato": nroContrato,
            },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const UploadAllIn = async (anio, formData) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.UploadAllIn(anio),
            formData,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        )
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const SaveExceptionReviewCobranza = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.SaveExceptionReviewCobranza,
            {
                "id_garantia_revision": obj.idGarantiaRevision,
                "estado": obj.estado,
                "updated_by": obj.updatedBy
            },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}
export const SaveExceptionReviewTesoreria = async (obj) => {
    const token = useGetToken();
    try {
        const response = await axios.post(
            PathNames.SaveExceptionReviewTesoreria,
            {
                "id_garantia_revision": obj.idGarantiaRevision,
                "estado": obj.estado,
                "updated_by": obj.updatedBy
            },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}
